import { connect } from 'react-redux';
import { State } from 'widgets/friends-referral/root/root.reducers';

import { InvitationWithTranslations } from './invitation.component';
import { ITranslationProps } from 'types/translation';

import { acceptInvitation } from '../friends-referral/friends-referral-store';
import { IGetInviteInfo } from '@sitegen/common/classes/friends-referral-api';
import { DATA_FORMAT } from '@sitegen/common/constants';

export interface IInvitationStoreProps {
    readonly paramThreshold: number;
    readonly invitationInfo: IGetInviteInfo;
    readonly statsFormatting: DATA_FORMAT;
}

export interface IInvitationDispatchProps {
    readonly acceptInvitation: () => Promise<void>;
}

const mapStateToProps = (state: State): IInvitationStoreProps => ({
    paramThreshold: state.friendsReferral.campaignInfo?.conversion.paramThreshold!,
    invitationInfo: state.friendsReferral.invitationInfo!,
    statsFormatting: state.config.friendsReferral?.dataFormat ?? DATA_FORMAT.NUMBER

});

const mapDispatchToProps = { acceptInvitation };

export type IInvitationProps = IInvitationStoreProps & IInvitationDispatchProps & ITranslationProps;

export default connect(mapStateToProps, mapDispatchToProps)(InvitationWithTranslations);
